import { ConnectMapToList, InspectPinMode, Map as MainMap, MapLayer } from '@/map'

export function Map() {
  return (
    <MainMap selectionContext="crud" selectionCategory="geofences" mapId="ww-map">
      <InspectPinMode mode="none" />

      <MapLayer uid="order" />
      <MapLayer uid="depot" />
      <MapLayer uid="region" />
      <MapLayer uid="roadSegment" />
      <MapLayer uid="geofence" interactive />
      <MapLayer uid="routePolyline" />
      <MapLayer uid="place" />
      <MapLayer uid="device" />
      <MapLayer uid="vehicle" />

      <ConnectMapToList category="geofences" />
    </MainMap>
  )
}
